export default __webpack_public_path__ + "static/media/exe.3030be80.svg";